/**
 * Defines the types of image bundles that can be captured.
 * Currently only freight photos are supported, but this can be extended
 * in the future for documents, signatures, etc.
 */
export enum ImageBundleType {
    FREIGHT_PHOTOS = "FREIGHT_PHOTOS"
}

/**
 * Display labels for each bundle type.
 */
export const ImageBundleTypeLabels: Record<ImageBundleType, string> = {
    [ImageBundleType.FREIGHT_PHOTOS]: "Freight Photos"
};

/**
 * Get the display label for a bundle type.
 */
export function getImageBundleTypeLabel(type: ImageBundleType): string {
    return ImageBundleTypeLabels[type] ?? type;
}

